module.exports = __webpack_public_path__ + "media/images/path-1@2x-2ea3bc25db54363d0a521e084e25752d.png";